/**
 * Need to fetch learningUnit By Id and keep in learningUnit
 */
import LearningUnit from '@/models/LearningUnit';

export const learningUnitInfoMixin = {
  computed: {
    name() {
      return this.learningUnit ? this.learningUnit.name : ' ';
    },
    description() {
      return this.learningUnit && this.learningUnit.description
        ? this.learningUnit.description
        : ' ';
    },
    type() {
      return this.learningUnit &&
        this.learningUnit.learning_unit_type &&
        this.learningUnit.learning_unit_type.name
        ? this.learningUnit.learning_unit_type.name
        : '';
    },
    status() {
      if (this.learningUnit) {
        if (this.learningUnit.required_review) {
          return 'Submitted for Publication';
        }

        if (this.learningUnit.is_published) {
          return 'Published';
        }

        return 'Draft';
      } else {
        return null;
      }
    },
    visibility() {
      if (this.learningUnit) {
        return this.learningUnit.is_listed ? 'Listed' : 'Unlisted';
      } else {
        return null;
      }
    },
    link() {
      const { learningUnitId } = this;

      const route = this.$router.resolve({
        name: 'micro-credentials/detail',
        params: { learningUnitId: learningUnitId }
      });

      return `${window.location.origin}${route.href}`;
    },

    learningUnitId() {
      return parseInt(this.$route.params.learningUnitId);
    },

    learningUnit() {
      return this.learningUnitId
        ? LearningUnit.query()
            .with('learning_unit_type')
            .with('learning_outcome')
            .with('sections.section_repeat')
            .with('posts')
            .with('media_detail_vimeo')
            .with('content_media_vimeo')
            .with('ultimate_learning_outcome')
            .with('learning_unit_options')
            .with('bunny_video')
            .find(this.learningUnitId)
        : null;
    },

    learningOutcome() {
      return this.learningUnit && this.learningUnit.ultimate_learning_outcome
        ? this.learningUnit.ultimate_learning_outcome
        : {};
    },

    sections() {
      return this.learningUnit && this.learningUnit.sections ? this.learningUnit.sections : [];
    },

    numberOfOnlineMeetings() {
      return this.learningUnit.number_of_online_meeting;
    },

    publicationStatus() {
      if (this.learningUnit.is_published === false && this.learningUnit.required_review === false) {
        return 'Draft';
      }
      if (this.learningUnit.required_review) {
        return 'Submitted for Review';
      }
      if (this.learningUnit.is_published === true) {
        return 'Published';
      }

      return 'error';
    },

    submittedDate() {
      return this.learningUnit.submitted_review_at;
    },

    what_to_do() {
      return this.learningUnit && this.learningUnit.what_to_do ? this.learningUnit.what_to_do : '-';
    },

    how_to_prepare() {
      return this.learningUnit && this.learningUnit.how_to_prepare
        ? this.learningUnit.how_to_prepare
        : '-';
    },

    who_this_for() {
      return this.learningUnit && this.learningUnit.who_this_for
        ? this.learningUnit.who_this_for
        : '-';
    },

    short_summary() {
      return this.learningUnit && this.learningUnit.short_summary
        ? this.learningUnit.short_summary
        : '-';
    },

    coverIdeas() {
      return this.learningUnit && this.learningUnit.cover_ideas
        ? this.learningUnit.cover_ideas.split('|').filter(Boolean).join(',')
        : '-';
    },

    coverImage() {
      return this.learningUnit && this.learningUnit.cover_image
        ? this.learningUnit.cover_image.url
        : '';
    }
  }
};
